import React, { useState, useEffect, useContext } from 'react';
import {
  Calendar,
  Clock,
  MapPin,
  Users,
  Check,
  X,
  HelpCircle,
  Loader,
  Film,
  Gamepad2,
  PartyPopper,
  Coffee,
  Dumbbell,
  GraduationCap,
  MoreHorizontal,
  UserCheck
} from 'lucide-react';
import { AuthContext } from '../context/AuthContext';
import { useSocket } from '../context/SocketContext';
import * as eventService from '../services/eventService';
import * as friendsService from '../services/friendsService';

const Events = () => {
  const { user } = useContext(AuthContext);
  const socket = useSocket();
  const { on, joinBeccoRoom } = socket;

  const [events, setEvents] = useState([]);
  const [becco, setBecco] = useState(null);
  const [loading, setLoading] = useState(true);
  const [filterStatus, setFilterStatus] = useState('all');

  // Tipi di evento con icone e colori
  const eventTypes = [
    { id: 'anime', label: 'Anime', icon: Film, color: '#EC4899', bgClass: 'bg-pink-500/20', textClass: 'text-pink-600 dark:text-pink-400' },
    { id: 'gaming', label: 'Gaming', icon: Gamepad2, color: '#8B5CF6', bgClass: 'bg-purple-500/20', textClass: 'text-purple-600 dark:text-purple-400' },
    { id: 'uscita', label: 'Uscita', icon: Users, color: '#10B981', bgClass: 'bg-green-500/20', textClass: 'text-green-600 dark:text-green-400' },
    { id: 'cinema', label: 'Cinema', icon: Film, color: '#F59E0B', bgClass: 'bg-amber-500/20', textClass: 'text-amber-600 dark:text-amber-400' },
    { id: 'cena', label: 'Cena', icon: Coffee, color: '#EF4444', bgClass: 'bg-red-500/20', textClass: 'text-red-600 dark:text-red-400' },
    { id: 'festa', label: 'Festa', icon: PartyPopper, color: '#F97316', bgClass: 'bg-orange-500/20', textClass: 'text-orange-600 dark:text-orange-400' },
    { id: 'sport', label: 'Sport', icon: Dumbbell, color: '#06B6D4', bgClass: 'bg-cyan-500/20', textClass: 'text-cyan-600 dark:text-cyan-400' },
    { id: 'studio', label: 'Studio', icon: GraduationCap, color: '#6366F1', bgClass: 'bg-indigo-500/20', textClass: 'text-indigo-600 dark:text-indigo-400' },
    { id: 'altro', label: 'Altro', icon: MoreHorizontal, color: '#6B7280', bgClass: 'bg-gray-500/20', textClass: 'text-gray-600 dark:text-gray-400' }
  ];

  useEffect(() => {
    if (user?.id) {
      loadBeccoAndEvents();
    }
  }, [user]);

  // Ricarica eventi quando cambia il filtro
  useEffect(() => {
    if (becco?.id) {
      loadEvents(becco.id);
    }
  }, [filterStatus]);

  // Listener WebSocket per aggiornamenti real-time eventi
  useEffect(() => {
    if (!on || !becco?.id) return;

    console.log('👤 USER - Sottoscrivo a event-changed e faccio join al room del Becco', becco.id);
    
    // Fai join al room del Becco per ricevere notifiche
    joinBeccoRoom(becco.id);

    const handleEventChange = (data) => {
      console.log('👤 USER - Event changed ricevuto:', data);
      console.log('👤 USER - Action:', data.action);
      loadEvents(becco.id);
    };

    const cleanup = on('event-changed', handleEventChange);
    return cleanup;
  }, [on, becco, joinBeccoRoom]);

  const loadBeccoAndEvents = async () => {
    setLoading(true);
    try {
      console.log('🔍 USER - Recupero info Becco...');
      console.log('🔍 USER - User context:', user);
      
      // Recupera info sul Becco
      const beccoResponse = await friendsService.getMyBecco();
      console.log('🔍 USER - Risposta getMyBecco:', beccoResponse);
      
      // Estrai il becco dalla risposta { success: true, data: { becco: ... } }
      const beccoData = beccoResponse.data || beccoResponse;
      console.log('🔍 USER - Becco data estratto:', beccoData);
      
      setBecco(beccoData.becco);

      if (beccoData.becco?.id) {
        await loadEvents(beccoData.becco.id);
      } else {
        console.warn('🔍 USER - Nessun Becco trovato nella risposta');
      }
    } catch (error) {
      console.error('❌ USER - Errore caricamento dati:', error);
      console.error('❌ USER - Dettagli errore:', error.response?.data);
    } finally {
      setLoading(false);
    }
  };

  const loadEvents = async (beccoId) => {
    try {
      const filters = {};
      if (filterStatus === 'upcoming') {
        filters.upcoming = true;
      }
      
      console.log('🔍 USER - Carico eventi per Becco ID:', beccoId);
      console.log('🔍 USER - User ID corrente:', user.id);
      
      const response = await eventService.getEvents(beccoId, filters);
      console.log('🔍 USER - Risposta completa dal server:', response);
      
      // Estrai l'array di eventi dalla risposta { success: true, data: [...] }
      const allEvents = response.data || [];
      console.log('🔍 USER - Eventi estratti:', allEvents);
      
      // Filtra solo eventi in cui l'utente è invitato o eventi pubblici
      const userEvents = allEvents.filter(event => {
        console.log(`🔍 USER - Verifico evento ${event.id}:`, {
          participants: event.participants,
          isPublic: event.isPublic
        });
        const isInvited = event.participants?.some(p => p.userId === user.id);
        console.log(`🔍 USER - Evento ${event.id} - isInvited:`, isInvited);
        return isInvited || event.isPublic;
      });

      // Ordina per data: prima i prossimi più vicini
      userEvents.sort((a, b) => new Date(a.eventDate) - new Date(b.eventDate));

      console.log('🔍 USER - Eventi filtrati per l\'utente:', userEvents);
      setEvents(userEvents);
      console.log('Events loaded for user:', userEvents.length);
    } catch (error) {
      console.error('Errore caricamento eventi:', error);
    }
  };

  const handleRespond = async (eventId, status) => {
    try {
      await eventService.respondToInvite(eventId, user.id, status);
      // Ricarica eventi per aggiornare lo stato
      if (becco?.id) {
        await loadEvents(becco.id);
      }
    } catch (error) {
      console.error('Errore risposta invito:', error);
      alert('Errore nella registrazione della risposta');
    }
  };

  const getEventTypeInfo = (typeId) => {
    return eventTypes.find(t => t.id === typeId) || eventTypes.at(-1);
  };

  const formatDate = (dateString) => {
    return new Date(dateString).toLocaleDateString('it-IT', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric'
    });
  };

  const isUpcoming = (event) => {
    // Confronta solo la data (senza ore) per includere eventi di oggi
    const eventDate = new Date(event.eventDate);
    eventDate.setHours(0, 0, 0, 0);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    return eventDate >= today;
  };

  const getMyParticipation = (event) => {
    return event.participants?.find(p => p.userId === user.id);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Loader className="w-8 h-8 animate-spin text-light-primary dark:text-dark-primary" />
      </div>
    );
  }

  if (!becco) {
    return (
      <div className="w-full space-y-6 p-6">
        <div className="bg-light-surface-container dark:bg-dark-surface-container rounded-lg shadow-surface-container p-6 text-center">
          <Calendar className="w-12 h-12 mx-auto mb-3 text-light-on-surface-variant dark:text-dark-on-surface-variant opacity-50" />
          <h3 className="text-xl font-bold text-light-on-surface dark:text-dark-on-surface mb-2">
            Nessun Becco Associato
          </h3>
          <p className="text-light-on-surface-variant dark:text-dark-on-surface-variant">
            Non sei ancora associato a nessun Becco. Chiedi al tuo Becco di invitarti!
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-light-surface dark:bg-dark-surface p-4 sm:p-6 lg:p-8">
      <div className="max-w-7xl mx-auto space-y-4 sm:space-y-6">
        {/* Header */}
        <div className="bg-light-surface-container dark:bg-dark-surface-container rounded-lg shadow-surface-container p-4 sm:p-6
          animate-fade-in opacity-0"
          style={{ animationDelay: '100ms', animationFillMode: 'forwards' }}>
        <div className="flex items-center gap-2 sm:gap-3">
          <Calendar className="w-6 h-6 sm:w-8 sm:h-8 text-light-secondary dark:text-dark-secondary" />
          <div>
            <h2 className="text-xl sm:text-2xl font-bold text-light-on-surface dark:text-dark-on-surface">
              Eventi di {becco.nickname || becco.username || becco.nome}
            </h2>
            <p className="mt-0.5 sm:mt-1 text-xs sm:text-sm text-light-on-surface-variant dark:text-dark-on-surface-variant">
              Vedi tutti gli eventi organizzati e rispondi agli inviti
            </p>
          </div>
        </div>
      </div>

        {/* Filtri */}
        <div className="flex flex-wrap gap-2 animate-fade-in opacity-0"
          style={{ animationDelay: '200ms', animationFillMode: 'forwards' }}>
        {[
          { id: 'all', label: 'Tutti' },
          { id: 'upcoming', label: 'Prossimi' }
        ].map(filter => (
          <button
            key={filter.id}
            onClick={() => setFilterStatus(filter.id)}
            className={`px-3 py-1.5 rounded-lg text-sm transition-all ${
              filterStatus === filter.id
                ? 'bg-light-secondary dark:bg-dark-secondary text-light-on-secondary dark:text-dark-on-secondary'
                : 'bg-light-surface-container dark:bg-dark-surface-container text-light-on-surface dark:text-dark-on-surface hover:bg-light-surface-variant dark:hover:bg-dark-surface-variant'
            }`}
          >
            {filter.label}
          </button>
        ))}
        </div>

        {/* Lista Eventi */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {events.length === 0 ? (
          <div className="col-span-full text-center py-12 bg-light-surface-container dark:bg-dark-surface-container rounded-lg">
            <Calendar className="w-12 h-12 mx-auto mb-3 text-light-on-surface-variant dark:text-dark-on-surface-variant opacity-50" />
            <p className="text-light-on-surface-variant dark:text-dark-on-surface-variant">
              Nessun evento disponibile
            </p>
          </div>
        ) : (
          events.map((event, index) => {
            const typeInfo = getEventTypeInfo(event.eventType);
            const TypeIcon = typeInfo.icon;
            const upcoming = isUpcoming(event);
            const myParticipation = getMyParticipation(event);

            return (
              <div
                key={event.id}
                className={`
                  ${typeInfo.bgClass}
                  rounded-lg shadow-surface-container p-3 sm:p-4 border-2 border-light-outline dark:border-dark-outline
                  animate-fade-in opacity-0 hover:shadow-lg transition-all
                `}
                style={{
                  animationDelay: `${300 + index * 100}ms`,
                  animationFillMode: 'forwards'
                }}
              >
                {/* Header Card */}
                <div className="flex items-start justify-between mb-3">
                  <div className="flex items-center gap-2">
                    <TypeIcon className={`w-5 h-5 ${typeInfo.textClass}`} />
                    <span className={`text-xs font-medium ${typeInfo.textClass}`}>
                      {typeInfo.label}
                    </span>
                  </div>
                  {myParticipation && (
                    <div className={`text-xs px-2 py-1 rounded-full ${
                      myParticipation.status === 'accepted' ? 'bg-green-500/20 text-green-600 dark:text-green-400' :
                      myParticipation.status === 'declined' ? 'bg-red-500/20 text-red-600 dark:text-red-400' :
                      myParticipation.status === 'maybe' ? 'bg-yellow-500/20 text-yellow-600 dark:text-yellow-400' :
                      'bg-gray-500/20 text-gray-600 dark:text-gray-400'
                    }`}>
                      {myParticipation.status === 'accepted' ? 'Accettato' :
                       myParticipation.status === 'declined' ? 'Rifiutato' :
                       myParticipation.status === 'maybe' ? 'Forse' : 'Invitato'}
                    </div>
                  )}
                </div>

                {/* Titolo */}
                <h3 className="text-lg font-bold text-light-on-surface dark:text-dark-on-surface mb-2 line-clamp-2">
                  {event.title}
                </h3>

                {/* Descrizione */}
                {event.description && (
                  <p className="text-sm text-light-on-surface-variant dark:text-dark-on-surface-variant mb-3 line-clamp-2">
                    {event.description}
                  </p>
                )}

                {/* Info */}
                <div className="space-y-2 text-sm mb-4">
                  <div className="flex items-center gap-2 text-light-on-surface-variant dark:text-dark-on-surface-variant">
                    <Calendar className="w-4 h-4" />
                    <span>{formatDate(event.eventDate)}</span>
                    {upcoming && (
                      <span className="ml-auto text-xs px-2 py-0.5 bg-green-500/20 text-green-600 dark:text-green-400 rounded-full">
                        Prossimo
                      </span>
                    )}
                  </div>

                  {(event.startTime || event.endTime) && (
                    <div className="flex items-center gap-2 text-light-on-surface-variant dark:text-dark-on-surface-variant">
                      <Clock className="w-4 h-4" />
                      <span>
                        {event.startTime?.substring(0, 5)}
                        {event.startTime && event.endTime && ' - '}
                        {event.endTime?.substring(0, 5)}
                      </span>
                    </div>
                  )}

                  {event.location && (
                    <div className="flex items-center gap-2 text-light-on-surface-variant dark:text-dark-on-surface-variant">
                      <MapPin className="w-4 h-4" />
                      <span className="line-clamp-1">{event.location}</span>
                    </div>
                  )}

                  <div className="flex items-center gap-2 text-light-on-surface-variant dark:text-dark-on-surface-variant">
                    <UserCheck className="w-4 h-4" />
                    <span>
                      {event.acceptedCount || 0} confermati
                      {event.maxParticipants && ` / ${event.maxParticipants}`}
                    </span>
                  </div>
                </div>

                {/* Azioni Risposta - sempre visibili per eventi futuri con invito */}
                {upcoming && myParticipation && (
                  <div className="flex flex-col xl:flex-row gap-2 pt-3 border-t border-light-outline dark:border-dark-outline">
                    <button
                      onClick={() => handleRespond(event.id, 'accepted')}
                      disabled={myParticipation.status === 'accepted'}
                      className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all ${
                        myParticipation.status === 'accepted'
                          ? 'bg-green-500/30 text-green-700 dark:text-green-300 cursor-not-allowed opacity-70'
                          : 'bg-green-500/20 text-green-600 dark:text-green-400 hover:bg-green-500/30'
                      }`}
                    >
                      <Check className="w-4 h-4 flex-shrink-0" />
                      <span>Accetto</span>
                    </button>
                    <button
                      onClick={() => handleRespond(event.id, 'maybe')}
                      disabled={myParticipation.status === 'maybe'}
                      className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all ${
                        myParticipation.status === 'maybe'
                          ? 'bg-yellow-500/30 text-yellow-700 dark:text-yellow-300 cursor-not-allowed opacity-70'
                          : 'bg-yellow-500/20 text-yellow-600 dark:text-yellow-400 hover:bg-yellow-500/30'
                      }`}
                    >
                      <HelpCircle className="w-4 h-4 flex-shrink-0" />
                      <span>Forse</span>
                    </button>
                    <button
                      onClick={() => handleRespond(event.id, 'declined')}
                      disabled={myParticipation.status === 'declined'}
                      className={`flex-1 flex items-center justify-center gap-1.5 px-3 py-2 rounded-lg text-xs sm:text-sm font-medium transition-all ${
                        myParticipation.status === 'declined'
                          ? 'bg-red-500/30 text-red-700 dark:text-red-300 cursor-not-allowed opacity-70'
                          : 'bg-red-500/20 text-red-600 dark:text-red-400 hover:bg-red-500/30'
                      }`}
                    >
                      <X className="w-4 h-4 flex-shrink-0" />
                      <span>Rifiuto</span>
                    </button>
                  </div>
                )}

                {/* Evento pubblico senza invito */}
                {upcoming && !myParticipation && event.isPublic && (
                  <div className="pt-3 border-t border-light-outline dark:border-dark-outline">
                    <p className="text-xs text-light-on-surface-variant dark:text-dark-on-surface-variant italic text-center">
                      Evento pubblico - Chiedi al Becco per partecipare
                    </p>
                  </div>
                )}
              </div>
            );
          })
        )}
        </div>
      </div>
    </div>
  );
};

export default Events;
